

export const CHANNEL_MAPPING = Object.freeze({
  EDITABLE_FIELDS: ['channelDescription', 'cognosParentChannel', 'cognosChannel', 'groupCode',
    'hcpMerchantChannel', 'hcpChannelType', 'marketplaceId', 'derivedMarketplaceId',
    'marketplaceName', 'excluded', 'hcpExcluded', 'ignored'],
  ALL_FIELDS: [
    'cognosChannelType', 'channelDescription', 'cognosParentChannel', 'cognosChannel',
    'groupCode', 'hcpMerchantChannel', 'hcpChannelType', 'marketplaceId',
    'derivedMarketplaceId', 'marketplaceName', 'excluded', 'hcpExcluded', 'ignored', 'comments'
  ],
  KEY_FIELDS: ['cognosChannelType', 'hcpChannelType'],
  TEMPLATE_COLUMNS: [
    'cognosChannelType', 'channelDescription', 'cognosParentChannel', 'cognosChannel',
    'groupCode', 'hcpMerchantChannel', 'hcpChannelType', 'marketplaceId',
    'derivedMarketplaceId', 'marketplaceName', 'excluded', 'hcpExcluded', 'ignored', 'comments'
  ],
  BADGE_TYPES: {
    NEW: { color: 'green', label: 'New' },
    EDITED: { color: 'blue', label: 'Staged' },
    NO_CHANGES: { color: 'grey', label: 'No Changes' },
    DELETED: { color: 'red', label: 'Deleted' },
    STAGED: { color: 'blue', label: 'Staged' },
    ERROR: { color: 'red', label: 'Error' },
  },
});



// WEBPACK FOOTER //
// ./src/components/config_central/channel_mapping/channel_mapping_constants.jsx